import { useEffect, useState } from "react";
import {
  PWA_EVENT,
  canInstall,
  isAndroid,
  isIOS,
  isSafari,
  isStandalone,
  promptInstall,
} from "../lib/pwa";

// Estado reativo do PWA: re-renderiza quando o prompt fica disponível ou o app
// é instalado.
export function usePwaInstall() {
  const [, force] = useState(0);
  useEffect(() => {
    const on = () => force((n) => n + 1);
    window.addEventListener(PWA_EVENT, on);
    return () => window.removeEventListener(PWA_EVENT, on);
  }, []);

  return {
    canInstall: canInstall(),
    isStandalone: isStandalone(),
    isIOS: isIOS(),
    isAndroid: isAndroid(),
    isSafari: isSafari(),
    promptInstall,
  };
}
